import React,{Component} from 'react';
import {connect} from 'react-redux';
import * as f2 from './store/actions';
class Form1 extends Component
{	
	state={
		name:'',
		email:'',
	}
	input(e)
	{
		let s=this.state
		let col=e.target.name

		let val=e.target.value
		s[col]=val
		this.setState(s)
	}
	insert(e)
	{
		e.preventDefault()
		this.props.insert(this.state,this.props.a.length+1)
	}
	render()
	{

		let {name,email}=this.state
		return (
				<div>
					<h1>new student</h1>
					<form onSubmit={this.insert.bind(this)}>
						<input onChange={this.input.bind(this)} name="name" value={name} placeholder="name" />
						<input onChange={this.input.bind(this)} name="email" value={email} placeholder="email" />
						<button>insert</button>
					</form>
				</div>
			)
	}
}
let f1=state=>state
export default connect(f1,f2)(Form1);